import React from 'react';

export default function FeatureSelectedItem( {item, onClick, height, group} ) {
    return (
        <>
        {group ? (
            <div className="flex items-center h-32 px-2">
                <span className="text-gray-800 uppercase font-semibold tracking-wide text-md">{item.label}</span>
            </div>
        )
        :
        (
        <div className="flex justify-between items-center px-2 h-24 hover:bg-purple-100" onClick={onClick} style={{height}}>
            <span className="text-md text-gray-700">{item.label}</span>
            <i className="fas fa-times text-gray-700 hover:text-purple-500 focus:border-purple-500"></i>
        </div>
        )
        }
        </>
    )
}